import React from "react";
import {Columns, Modal, Section, Form, Table, Button} from "react-bulma-components";
import ApprovalRow from "./ApprovalRow";
import axios from "axios";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {addXeroVat} from "../../utils";



export default function ApprovalModal({data, show, setShow, nominalCodes, paymentTypes, onStateChange, onSave, onCancel, codeObjects, paymentObjects, trackingOptions, trackingOptionObjects, view}){

    const handleStateChange = (data) => {
        if(view === "ready_to_approve"){
            onStateChange(data, "approved")
        }
        else{
            onStateChange(data, "ready")
        }
    }

    const getTotalChargeToUsNoVat = () => {
        let total = 0;
        data.results.forEach(part => {
            total += part.cost;
        });
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    const getTotalChargeToUs = () => {
        let total = 0;
        data.results.forEach(part => {
            total += addXeroVat(part.cost_vat, part.cost);
        });
        return (Math.round((total + Number.EPSILON) * 100) / 100)
    }

    return (
        <Modal
            show={show}
            onClose={() => {
                onCancel();
            }}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Form.Label>Supplier</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={(data.results.length > 0) ? data.results[0].supplier.display_name : ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Total Part Cost (£)</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={(data.results.length > 0) ? getTotalChargeToUsNoVat() : "£0"}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Total Part Cost Inc. VAT (£)</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={(data.results.length > 0) ? getTotalChargeToUs() : "£0"}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table size={"fullwidth"}>
                                <thead>
                                    <tr>
                                        <th>Part Name</th>
                                        <th>Cost</th>
                                        <th>Date Ordered</th>
                                        <th>Payment Type</th>
                                        <th>Nominal Code</th>
                                        <th>Invoice Number</th>
                                        <th>Tracking Category</th>
                                        <th>Invoice Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((part, index) => (
                                    <ApprovalRow
                                        part={part}
                                        index={index}
                                        nominalCodes={nominalCodes}
                                        paymentTypes={paymentTypes}
                                        codeObjects={codeObjects}
                                        paymentObjects={paymentObjects}
                                        onSave={onSave}
                                        trackingOptions={trackingOptions}
                                        trackingOptionObjects={trackingOptionObjects}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                fullwidth
                                onClick={() => handleStateChange(data.results)}
                            >
                                {view === "ready_to_approve" ? "Approve" : "Ready to Approve"}
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )




}